// extracted by mini-css-extract-plugin
export default {"title":"agentInsurance_title__bogO+","number":"agentInsurance_number__nDB0o"};